export const LocalStorage = {
    STORED_USER: 'STORED_USER',
    EZTURN4_TOKEN: 'EZTURN4_TOKEN',
}
